import React, {memo, useEffect, useState} from 'react';
import {
  TouchableOpacity,
  Text,
  Pressable,
  Animated,
  Easing,
  View,
} from 'react-native';

import {StyleSheet} from 'react-native';
import {colorPalette, colors} from '../../../core/config/color.config';
import {Icon, Overlay} from 'react-native-elements';

import useStores from '../../stores/useStores';

import {
  ConsultationRequestResBody,
  ConsultationStatusEnum,
} from '../../server/types/consultation.types';
import CustomModalNative from '../../components/modal/CustomModal.native';
import ConsultationCancelConfirmationModal from '../modal/ConsultationCancelConfirmationModal';
import ConsultationCancel from './ConsultationCancel';
import {useCancelConsultationDetail, useGetConsultationDetail} from '../../server/react-query/useConsultation';
import ConsultationAcceptDecline from './ConsultationAcceptDecline';
import {useNavigation} from '@react-navigation/native';
import { NavigationKey } from '../../navigations/config';
import { width, height, totalSize } from 'react-native-dimension';

interface ConsultationListItemMenuProps {
  item: ConsultationRequestResBody;
  isMenuOpen: boolean;
  onCloseMenuPress?: () => void;
  onPress?: () => void;
}

const ConsultationListItemMenu = (props: ConsultationListItemMenuProps) => {
  const {authStore} = useStores();
  const navigation = useNavigation();


  const currentLoggedInUserRole = authStore.userRole;

  const {data: serviceRequest, isLoading: isConsultationDetailLoading} = useGetConsultationDetail({
    serviceRequestId: props.item.serviceRequestId || '',
  });

  const [showActions, setShowActions] = useState(false);
  const [isCancelConfirmModalVisible, setIsCancelConfirmModalVisible] =
    useState(false);

  const [isArchiveConfirmModalVisible, setIsArchiveConfirmModalVisible] =
    useState(false);

  const slideAnim = useState(new Animated.Value(0))[0];
  const opacityAnim = useState(new Animated.Value(0))[0];

  const [isLoading, setIsLoading] = useState(false);

  const cancelMutation = useCancelConsultationDetail({
    serviceRequestId: props.item.serviceRequestId,
    status: ConsultationStatusEnum.CANCELLED,
  });

  const archieveMutation = useCancelConsultationDetail({
    serviceRequestId: props.item.serviceRequestId,
    status: ConsultationStatusEnum.ARCHIVED,
  });

  

  const toggleActions = () => {

    props.onCloseMenuPress();
    // if (showActions) {

    //   Animated.parallel([
    //     Animated.timing(opacityAnim, {
    //       toValue: 0,
    //       duration: 200,
    //       useNativeDriver: true,
    //     }),
    //     Animated.timing(slideAnim, {
    //       toValue: 0,
    //       duration: 200,
    //       useNativeDriver: true,
    //     }),
    //   ]).start(() => setShowActions(false));
    // } else {
    //   setShowActions(true);
    //   Animated.parallel([
    //     Animated.timing(opacityAnim, {
    //       toValue: 1,
    //       duration: 200,
    //       useNativeDriver: true,
    //     }),
    //     Animated.timing(slideAnim, {
    //       toValue: 1,
    //       duration: 200,
    //       easing: Easing.out(Easing.ease),
    //       useNativeDriver: true,
    //     }),
    //   ]).start();
    // }
  };

  useEffect(() => {
    if (props.isMenuOpen) {
      setShowActions(true);
      Animated.parallel([
        Animated.timing(opacityAnim, {
          toValue: 1,
          duration: 200,
          useNativeDriver: true,
        }),
        Animated.timing(slideAnim, {
          toValue: 1,
          duration: 200,
          easing: Easing.out(Easing.ease),
          useNativeDriver: true,
        }),
      ]).start();
    } else {
      Animated.parallel([
        Animated.timing(opacityAnim, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
        }),
        Animated.timing(slideAnim, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
        }),
      ]).start(() => setShowActions(false));
    }
  }, [props.isMenuOpen]);

  const handleDeleteRequest = async () => {
    try {
      setIsLoading(true);
      await cancelMutation.mutateAsync();
      props.onCloseMenuPress();

      setTimeout(()=>{
        setIsLoading(false);
      },1000);
      
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleAcceptRequest = () => {
    navigation.navigate(NavigationKey.CONSULTATION_REQUEST_ACCEPTANCE, {
      onConfirm: navigation.goBack,
      serviceRequest: props.item,
    });
  };

  const handleArchiveRequest = async () => {
    try {
      setIsLoading(true);
      await archieveMutation.mutateAsync();
      props.onCloseMenuPress();
      setTimeout(()=>{
        setIsLoading(false);
      },1000);
      
    } catch (error) {
      setIsLoading(false);
    }
  }

  return (
    <>
      {showActions ? (
        <Animated.View
          style={[
            styles.actionsRow,
            {
              opacity: opacityAnim,
              transform: [
                {
                  translateY: slideAnim.interpolate({
                    inputRange: [0, 1],
                    outputRange: [-10, 0], // Slide down
                  }),
                },
              ],
            },
          ]}>
          <TouchableOpacity onPress={toggleActions}>
            <Icon
              name="close-circle"
              type="material-community"
              size={totalSize(3)}
              color={colorPalette.grey}
            />
          </TouchableOpacity>


          {/* Patient  && !props.item.procedure */}
          {
            currentLoggedInUserRole === 'patient' && (
              <Pressable
                onPress={() =>
                  setIsCancelConfirmModalVisible(!isCancelConfirmModalVisible)
                }
                style={[
                    styles.actionButton, 
                    styles.cancel 
                ]}
              >
                <Text 
                  style={[
                    styles.actionText 
                  ]}
                >
                    Cancel Request
                </Text>
              </Pressable>
            )
          }
          
          {/* Practitioner */}
          {props.item?.status === ConsultationStatusEnum.PENDING &&
            !props.item.procedure &&
            currentLoggedInUserRole === 'practitioner' &&
            props.item?.subject && (
              <>
                <Pressable
                  onPress={()=>{
                        // setIsCancelConfirmModalVisible(!isCancelConfirmModalVisible)
                        navigation.navigate(NavigationKey.CONSULTATION_DECLINE, {
                                params: {
                                  id: props.item.serviceRequestId,
                                },
                        });
                  }}
                  style={[
                      styles.actionButton, 
                      styles.decline
                  ]}
                >
                  <Text 
                    style={[
                      styles.declineText
                    ]}
                  >
                    Decline
                  </Text>
                </Pressable>

                <Pressable
                  onPress={handleAcceptRequest}
                  style={[
                      styles.actionButton, 
                      styles.accept
                  ]}
                >
                  <Text 
                    style={[
                      styles.actionText,
                    ]}
                  >
                    Accept
                  </Text>
                </Pressable>
              </>
          )}

          {
            currentLoggedInUserRole === 'practitioner' && (
              <Pressable
                  onPress={() =>
                    setIsArchiveConfirmModalVisible(!isArchiveConfirmModalVisible)
                  }
                  style={[
                      styles.actionButton, 
                      styles.archive
                  ]}
                >
                  <Text 
                    style={[
                      styles.actionText,
                    ]}
                  >
                    Archive
                  </Text>
                </Pressable>
            )
          }

          
        </Animated.View>
      ) : (
        <></>
      )}

      <Overlay
        isVisible={isCancelConfirmModalVisible}
        overlayStyle={sharedStyles.overlayContainer}
      >
        <ConsultationCancelConfirmationModal
          isLoading={isLoading}
          title={currentLoggedInUserRole === 'patient' ? "Are you sure you want to cancel this request?" : "Are you sure you want to decline this request?"}
          primaryBtnText={"Yes"}
          secondaryBtnText={"No"}
          onConfirm={handleDeleteRequest}
          onCancel={() =>
            setIsCancelConfirmModalVisible(!isCancelConfirmModalVisible)
          }
        />
      </Overlay>

      <Overlay
        isVisible={isArchiveConfirmModalVisible}
        overlayStyle={sharedStyles.overlayContainer}>
        <ConsultationCancelConfirmationModal
          isLoading={isLoading}
          title={"Are you sure you want to archive this consultation?"}
          primaryBtnText={"Yes"}
          secondaryBtnText = {"No"}
          onConfirm={handleArchiveRequest}
          onCancel={() =>
            setIsArchiveConfirmModalVisible(!isArchiveConfirmModalVisible)
          }
        />
      </Overlay>
    </>
  );
};

const styles = StyleSheet.create({
  actionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 0,
    marginLeft: 0, // to align under text (adjust based on avatar size)
    marginRight: width(3),
    gap: totalSize(1),
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center', 
    paddingVertical: totalSize(0.7),
    paddingHorizontal: totalSize(1.2),
    borderRadius: totalSize(5),
  },
  decline: {
    borderColor: '#FFA500',
    borderWidth: 1,
    // paddingVertical: height(0.8),
    paddingHorizontal: totalSize(1.6),
    
  },
  accept: {
    backgroundColor: '#FFA500',
    // paddingVertical: height(1),
    paddingHorizontal: totalSize(1.7),
    fontSize: totalSize(1.3),
    borderWidth: 1,
    borderColor: '#FFA500',

  },
  cancel: {
    backgroundColor: '#FFA500',
    paddingVertical: 8,
  },
  archive: {
    backgroundColor: '#3FB4E6',
    // paddingVertical: height(1),
    paddingHorizontal: totalSize(1.6),
    fontSize: totalSize(1.3),
    borderWidth: 1,
    borderColor: '#3FB4E6',
  },
  actionText: {
    fontSize: totalSize(1.3),
    color: colorPalette.white,
    fontFamily: 'Quicksand-Bold',
    textAlign: 'center',
    marginTop:-height(0.2)
    
  },
  declineText:{
    fontSize: totalSize(1.3),
    color: colors.brightYellow.regular,
    fontFamily: 'Quicksand-Bold',
    marginTop:-height(0.2)
  },
  root: {
    flexDirection: 'row',
    paddingHorizontal: 24,
    paddingVertical: 24,
    borderBottomWidth: 1,
    borderBottomColor: colorPalette.light,
  },
  photo: {},
  message: {
    // flex: 1,
    paddingHorizontal: 16,
    paddingTop: 4,
  },
  timestamp: {
    paddingTop: 4,
    alignContent: 'flex-end',
    width: '15%',
  },
});

const sharedStyles = StyleSheet.create({
  overlayContainer: {
    borderRadius: totalSize(2.5),
    marginHorizontal: 40,
    width: width(90),
    borderColor: 'black',
    borderWidth: totalSize(0.15),
  },
});

export default memo(ConsultationListItemMenu);
